import React from 'react'
import LoadingBackdrop from '../../../../components/LoadingBackdrop'

interface DeclarationLayoutProps {
  interactionsLocked: boolean
  headerLeft: React.ReactNode
  headerCenter: React.ReactNode
  headerRight?: React.ReactNode
  footerLeft?: React.ReactNode
  footerRight: React.ReactNode
  children: React.ReactNode
}
function DeclarationLayout({
  interactionsLocked,
  headerLeft,
  headerCenter,
  headerRight,
  footerLeft,
  footerRight,
  children,
}: DeclarationLayoutProps) {
  return (
    <div className="declaration">
      {interactionsLocked && (
        <div className="overlay--backdrop" id="loading">
          <LoadingBackdrop loading={interactionsLocked} isInTable={false} />
        </div>
      )}
      <div className="declaration__header">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg declaration__header--left">{headerLeft}</div>
            <div className="col-lg-auto declaration__header--center pe-3 d-flex align-items-end">{headerCenter}</div>
            {headerRight && (
              <div className="col-lg-auto d-none d-lg-block declaration__header--right">{headerRight}</div>
            )}
          </div>
        </div>
      </div>
      <div className="declaration__body">{children}</div>
      <div className="declaration__footer fixed-bottom">
        <div className="declaration__footer-inner">
          {footerLeft ?? null}
          {footerRight}
        </div>
      </div>
    </div>
  )
}

DeclarationLayout.defaultProps = {
  headerRight: null,
  footerLeft: null,
}

export default DeclarationLayout
